<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <h1 align="center">
          Bienvenue sur <b class="blue-bold">Project A</b> !
        </h1>
      </v-col>
      <v-col cols="12" align="center" class="my-4">
        <img class="logo" src="../assets/workout.png" />
      </v-col>
      <v-col class="my-16" cols="10" sm="12" align="center">
        <p class="my-2">
          Sur cette plateforme, vous pourrez manager vos
          <b class="blue-bold">séances de sport</b>
          personnelles. Cet utilitaire vous permettra d'enregistrer vos
          sessions, au jour le jour, ainsi que de laisser une note relatant
          votre entraînement et votre ressenti.
        </p>
        <p class="my-6">
          Mais tout d'abord, il faut vous <b class="blue-bold">connecter</b>!
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.logo {
  height: 150px;
  width: 150px;
}
.blue-bold {
  color: #2837bf;
}
</style>


